import Bootstrap from 'bootstrap';
import Fancybox from '@fancyapps/fancybox';

import {default as setup_single_investycje_view} from './partials/single-inwestycje';
import {default as setup_tax_inwestycje_kategorie_view} from './partials/taxonomy-inwestycje-kategorie';
import {setup_user_maps as setup_google_maps} from "./partials/google-maps/setup_maps_for_user";

$(function () {
    const body = $('body');
    if (body.hasClass('single-inwestycje')) {
        setup_single_investycje_view();
    } else if (body.hasClass('tax-inwestycje-kategorie')) {
        setup_tax_inwestycje_kategorie_view();
    }
});

// setup google maps asap
setup_google_maps();
